import meetingState from '../../../../data/constants/meetingState';
import { startingMeetingFilter } from '../../../../data/filters/meetingFilters';

export function confirmedStartingMeetingFilter(meeting) {
    return [meetingState.CONFIRMED].includes(meeting._state) && startingMeetingFilter(meeting);
}
